export const COMPANY = {
  name: 'PT Wardah Pratama Transport',
  short: 'WP Transport',
  address: 'Otista Village Blok I No. 10, Garut',
  phoneDisplay: '0823-2062-3330',
  whatsapp: '6282320623330',
  tiktok: '@sewamobilgarut_0',
  tiktokUrl: 'https://www.tiktok.com/@sewamobilgarut_0',
}

export const waLink = (message: string) =>
  `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(message)}`

export const NAV_LINKS = [
  { label: 'Beranda', href: '#beranda' },
  { label: 'Tentang Kami', href: '#tentang' },
  { label: 'Layanan', href: '#layanan' },
  { label: 'Armada', href: '#armada' },
  { label: 'Testimoni', href: '#testimoni' },
  { label: 'Kontak', href: '#kontak' },
]
